import { VERIFIED_CREATIVE_WARNING_MESSAGE } from './constants';

export const createVerifiedCreativeWarningMessage = (adUuidsWithApprovedVastUrl: string[]): string => {
  return `${VERIFIED_CREATIVE_WARNING_MESSAGE}${
    adUuidsWithApprovedVastUrl.length > 1 ? 's' : ''
  } ${adUuidsWithApprovedVastUrl.join(', ')}.`;
};
